import { render, staticRenderFns } from "./PreReg.vue?vue&type=template&id=2f40538a&"
import script from "./PreReg.vue?vue&type=script&lang=js&"
export * from "./PreReg.vue?vue&type=script&lang=js&"
import style0 from "./PreReg.vue?vue&type=style&index=0&id=2f40538a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports